import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';
import { MENUITEMS, visibleFor } from '../Sidebar/Menu';

/**
 * Barra superior de 70px: botón de menú (sólo móvil) y buscador de
 * navegación.
 *
 * El buscador es el mismo de antes —filtra los items del menú por título y
 * lleva a su ruta— sin el typeahead de la plantilla, que dependía de sus
 * clases y de los SvgIcon retirados. Respeta el rol: sólo aparecen los
 * destinos que el usuario puede abrir.
 *
 * Perfil y salir viven ahora al pie de la barra lateral, como en el diseño.
 * El interruptor de modo oscuro (RightHeader/MoonLight) y el logo de
 * Leftbar quedan fuera: no están diseñados. Sus archivos siguen ahí.
 */
const Header = ({ onMenu }) => {
  const { admin } = useAdmin();
  const [query, setQuery] = useState('');

  const term = query.trim().toLowerCase();
  const results = term
    ? MENUITEMS.flatMap((group) => visibleFor(admin?.role, group.Items)).filter((item) =>
        item.title.toLowerCase().includes(term)
      )
    : [];

  return (
    <header className="ui-topbar">
      <button type="button" className="ui-topbar__burger" onClick={onMenu} aria-label="Abrir menú">
        <i className="ri-menu-line" />
      </button>

      <div className="ui-topbar__search">
        <i className="ri-search-line" />
        <input
          type="search"
          value={query}
          placeholder="Buscar en todo el panel"
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => e.key === 'Escape' && setQuery('')}
        />
        {term && (
          <div className="ui-topbar__results">
            {results.length === 0 ? (
              <div className="ui-topbar__empty">Sin resultados para “{query}”.</div>
            ) : (
              results.map((item) => (
                <Link key={item.path} to={item.path} onClick={() => setQuery('')}>
                  <i className={item.icon} />
                  <span>{item.title}</span>
                </Link>
              ))
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
